import {IWixAPI} from '@wix/yoshi-flow-editor'
import {draftEventPreviewUrlQueryParamName} from '@wix/wix-events-commons-statics'

export const getDraftToken = (wixCodeApi: IWixAPI) => {
  const {query} = wixCodeApi.location
  return query[draftEventPreviewUrlQueryParamName]
}
